module.exports = __webpack_public_path__ + "img/111.1.81190487.jpg";